// Numerology calculator utilities (Pythagorean & Chaldean)

const pythagoreanMap = {
  A: 1, B: 2, C: 3, D: 4, E: 5, F: 6, G: 7, H: 8, I: 9,
  J: 1, K: 2, L: 3, M: 4, N: 5, O: 6, P: 7, Q: 8, R: 9,
  S: 1, T: 2, U: 3, V: 4, W: 5, X: 6, Y: 7, Z: 8,
};

const chaldeanMap = {
  A: 1, I: 1, J: 1, Q: 1, Y: 1,
  B: 2, K: 2, R: 2,
  C: 3, G: 3, L: 3, S: 3,
  D: 4, M: 4, T: 4,
  E: 5, H: 5, N: 5, X: 5,
  U: 6, V: 6, W: 6,
  O: 7, Z: 7,
  F: 8, P: 8,
};

export const reduceToSingle = (num, keepMaster = true) => {
  let n = Math.abs(num);
  while (n > 9) {
    if (keepMaster && (n === 11 || n === 22 || n === 33)) return n;
    n = String(n).split('').reduce((s, d) => s + Number(d), 0);
  }
  return n;
};

export const calcNameNumerology = (name, system = 'pythagorean') => {
  const cleaned = (name || '').toUpperCase().replace(/[^A-Z]/g, '');
  if (!cleaned) return null;
  const map = system === 'chaldean' ? chaldeanMap : pythagoreanMap;
  let total = 0;
  const breakdown = cleaned.split('').map((ch) => {
    const v = map[ch] || 0;
    total += v;
    return { letter: ch, value: v };
  });
  const single = reduceToSingle(total);
  return { total, single, breakdown, system };
};

export const calcLifePath = (dobStr) => {
  if (!dobStr) return null;
  const digits = dobStr.replace(/[^0-9]/g, '');
  if (digits.length < 6) return null;
  const sum = digits.split('').reduce((s, d) => s + Number(d), 0);
  return reduceToSingle(sum);
};

export const calcCompatibility = (name1, name2, dob1, dob2) => {
  const n1 = calcNameNumerology(name1);
  const n2 = calcNameNumerology(name2);
  const lp1 = calcLifePath(dob1);
  const lp2 = calcLifePath(dob2);
  if (!n1 || !n2 || !lp1 || !lp2) return null;

  const nameDiff = Math.abs(n1.single - n2.single);
  const lifeDiff = Math.abs(lp1 - lp2);
  // simple harmonic score
  const nameScore = 100 - nameDiff * 9;
  const lifeScore = 100 - lifeDiff * 9;
  const score = Math.max(40, Math.round(nameScore * 0.5 + lifeScore * 0.5));
  let band = 'Harmonious';
  if (score < 55) band = 'Challenging';
  else if (score < 70) band = 'Workable';
  else if (score < 85) band = 'Strong';
  else band = 'Soulmate Resonance';

  const insight = {
    'Soulmate Resonance':
      'Your numbers vibrate in profound harmony. Deep emotional, mental and spiritual alignment is indicated.',
    Strong:
      'You complement each other beautifully. A balanced bond with mutual growth and stability.',
    Workable:
      'A relationship of opposites that can flourish with conscious effort, communication and respect.',
    Challenging:
      'Patterns of friction are indicated. Numerological remedies and intentional rituals can soften tensions.',
  };

  return {
    name1Number: n1.single,
    name2Number: n2.single,
    life1: lp1,
    life2: lp2,
    score,
    band,
    insight: insight[band],
  };
};

export const numberMeanings = {
  1: { title: 'The Pioneer', text: 'Leadership, originality, courage. Born to initiate.' },
  2: { title: 'The Diplomat', text: 'Harmony, partnership, intuition. A graceful balancer.' },
  3: { title: 'The Creator', text: 'Expression, joy, creativity. Magnetic communicator.' },
  4: { title: 'The Builder', text: 'Discipline, structure, loyalty. Foundation of trust.' },
  5: { title: 'The Free Spirit', text: 'Adventure, change, freedom. Catalyst of transformation.' },
  6: { title: 'The Nurturer', text: 'Love, responsibility, beauty. Guardian of relationships.' },
  7: { title: 'The Seeker', text: 'Wisdom, mystery, spirituality. The mystic mind.' },
  8: { title: 'The Achiever', text: 'Power, abundance, ambition. Manifesto of success.' },
  9: { title: 'The Humanitarian', text: 'Compassion, completion, vision. An old soul.' },
  11: { title: 'Master Intuitive', text: 'Spiritual messenger. Visionary frequency.' },
  22: { title: 'Master Builder', text: 'Dreams turned into legacies. Architect of empires.' },
  33: { title: 'Master Teacher', text: 'Selfless devotion. Healer of generations.' },
};
